import {
   SearchResultItem,
   GuideSearchResultItem,
   NewsSearchResultItem,
   PostSearchResultItem,
} from '../types';

/**
 * Type guard to check if search result is a guide
 */
export function isGuideResult(hit: SearchResultItem): hit is GuideSearchResultItem {
   return hit.doctype === 'guide';
}

/**
 * Type guard to check if search result is a news article
 */
export function isNewsResult(hit: SearchResultItem): hit is NewsSearchResultItem {
   return hit.doctype === 'news';
}

/**
 * Type guard to check if search result is a forum post
 */
export function isPostResult(hit: SearchResultItem): hit is PostSearchResultItem {
   return hit.doctype === 'post';
}
